import { db } from "../../../config/firebaseconfig";
import parseSnapshot from "../../parseSnapshot";

/**
 * Creates a unique username in instances where a username is
 * already taken.
 * @param {string} district id of the school district
 * @param {string} name username to look up
 * @param {string} collection db collection name
 * @returns unique username string or null 
 */
export default function findUniqueUsername (district, name, collection) {
  // get all users in district (students or educators)
  const nameLength = name.length
  return db.collection(collection).where('schoolDistrict', '==', district).get()
    .then(querySnapshot => {
      const users = parseSnapshot(querySnapshot)
      let nameConflicts = {}
      Object.values(users).forEach(user => {
        if (user.username) {
          if (user.username.substring(0, nameLength) === name) {
            nameConflicts[user.username] = true 
          }
        }
      })
      for (let i = 1; i <= Object.keys(nameConflicts).length; i++) {
        if (!nameConflicts[name + i]) return name + i
      }
      return null
    })

}


// WEBPACK FOOTER //
// ./src/helpers/assessment/uploadCSV/findUniqueUsername.js